import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import reviewImage from "assets/images/under-review-edisclosure.svg";
import { Button } from "components/ui/button/Button";
import style from "./esign-under-review.module.scss";
import { UNDER_REVIEW_DESCRIPTION, UNDER_REVIEW_TITLE } from "utilities/Constant";

export interface ESignUnderReviewModalProps {
  handleClose: () => void;
}

export default function ESignUnderReviewModal({ handleClose }: ESignUnderReviewModalProps): JSX.Element {
  return (
    <div className={style.underReviewModal} data-testid="e-sign-under-review">
      <div className={style.modalHeader}>
        <div>
          <FontAwesomeIcon icon={solid("xmark")} className={style.closeIcon} onClick={handleClose} />
        </div>
      </div>

      <div className={style.modalBody}>
        <img className={style.underReviewImage} src={reviewImage} alt="Under Review" />
        <div>
          <p className={style.title}>{UNDER_REVIEW_TITLE}</p>
          <p className={style.description}>{UNDER_REVIEW_DESCRIPTION}</p>
        </div>
      </div>

      <div className={style.modalFooter}>
        <Button className={style.closeButton} type="round" variant="primary" size="large" onClick={handleClose}>
          Close
        </Button>
      </div>
    </div>
  );
}
